<template>
  <v-data-table
    :items="getItems"
    :headers="headers"
    :loading="loading"
    sort-by="quantity"
    :sort-desc="true"
    :items-per-page="getItems.length + 1"
    hide-default-footer
  >
    <template v-slot:item.quantity="{ item }">
      {{ item.quantity }}
      <span class="caption">{{ item.unit }}</span>
    </template>
    <template v-slot:item.actions="{ item }">
      <v-row align="center" justify="end" no-gutters>
        <v-btn
          v-if="getIsAdmin"
          icon
          :small="!$vuetify.breakpoint.xsOnly"
          @click="
            $router.push({
              name: 'RecipeEditor',
              params: { id: item.recipeId }
            })
          "
        >
          <v-icon :small="!$vuetify.breakpoint.xsOnly">fa-edit</v-icon>
        </v-btn>
        <v-btn
          v-else
          icon
          :small="!$vuetify.breakpoint.xsOnly"
          @click="
            $router.push({
              name: 'RecipeViewer',
              params: { id: item.recipeId }
            })
          "
        >
          <v-icon :small="!$vuetify.breakpoint.xsOnly"
            >fa-external-link-alt</v-icon
          >
        </v-btn>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ProductRecipeLinkGrid",
  props: {
    id: {
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getRecipes", "getProducts", "getIsAdmin"]),
    getItems() {
      const recipes = this.getRecipes.filter(
        r =>
          r.ingredients.find(i => i.pk_recette_produit === this.id) !==
          undefined
      );

      return recipes.map(r => {
        const i = r.ingredients.find(i => i.pk_recette_produit === this.id);
        return {
          quantity: i.quantite,
          unit: i.unite_mesure,
          recipe: r.nom,
          recipeId: r.id
        };
      });
    }
  },
  data() {
    return {
      headers: [
        { value: "recipe", text: "Recette" },
        { value: "quantity", text: "Quantité utilisé" },
        { value: "actions", text: "" }
      ]
    };
  }
};
</script>

<style></style>
